import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useAppDispatch } from 'hooks/redux';
import { FETCH_TAX_PENSIONSINFO_CANCELLED } from 'constants/routeNames';
import { updateFetchFailTaxAndPensionsInfo } from 'actions/fetchTaxAndPensionsInfo';

export const useOnFetchCancel = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation();

  return useCallback(
    (failType: string) => {
      dispatch(updateFetchFailTaxAndPensionsInfo(failType));
      navigation.navigate(FETCH_TAX_PENSIONSINFO_CANCELLED);
    },
    [navigation, dispatch]
  );
};
